import { useSelector } from 'react-redux';

export const Computer = () => {
  const currentSimbolComputer = useSelector(
    (state) => state.round.currentSimbolComputer
  );
  const isAnimation = useSelector((state) => state.info.isAnimation);

  const classSimbolComputer = (count) => {
    switch (count) {
      case 0:
        return '';
      case 1:
        return 'gamer__rock';
      case 2:
        return 'gamer__scissors';
      case 3:
        return 'gamer__paper';
      default:
        return 'gamer__scissors';
    }
  };

  return (
    <div className='field__right gamer'>
      <div className={isAnimation ? 'gamer__animation' : null}></div>
      <div className={classSimbolComputer(currentSimbolComputer)}></div>
    </div>
  );
};
